<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <h4>Título</h4>
        <span v-if="project.projectType == 'event'">Qual o nome do seu evento?</span>
        <span v-else>Qual o nome do seu projeto?</span>
      </div>

      <div class="col-md-8">
          <div class="form-group">
            <input class="form-control" type="text" v-model="title" maxlength="40" @input="editSlug()"/>
            <span>Até 40 caracteres</span>
          </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4>Endereço da URL</h4>
        <span>Este é o endereço de seu projeto. Importante: ao modificar o "título" de seu projeto este endereço mudará automaticamente.</span>
      </div>

      <div class="col-md-8">
          <div class="form-group">
            <input class="form-control" type="text" v-model="slug" maxlength="40" readonly/>
          </div>
      </div>
    </div>

    <div class="row" v-if="project.projectType != 'event'">
      <div class="col-md-4">
        <h4>Arrecadação</h4>
        <span>Defina a meta de arrecadação da Organização Social.</span>
      </div>

      <div class="col-md-8">
          <b-form-radio-group id="radios2" v-model="donationType" name="radioSubComponent2">
            <b-form-radio value="single">Pontual</b-form-radio>
            <b-form-radio value="monthly">Contínua</b-form-radio>
          </b-form-radio-group>
          <div class="form-group" v-if="donationType == 'single'">
            <input type="text" v-money="money" v-model="donationTotal"/>
            <p>Quanto você precisa arrecadar?</p>
          </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4>Valor Mínimo</h4>
        <span v-if="project.projectType == 'event'">Defina o valor mínimo de doação para seu evento. (Valores à partir de R$ 20)</span>
        <span v-else>Defina o valor mínimo de doação para seu projeto. (Valores à partir de R$ 20)</span>
      </div>

      <div class="col-md-8">
          <div class="form-group">
            <input v-money="money" class="form-control" type="text" v-model="minimumValue"/>
          </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4>Opções de Valores</h4>
        <span>Defina as opções de valores de doação</span>
      </div>

      <div class="col-md-8 row">
          <div class="form-group col-md">
            <input v-money="money" class="form-control" type="text" v-model="optionalValue1"/>
          </div>
          <div class="form-group col-md">
            <input v-money="money" class="form-control" type="text" v-model="optionalValue2"/>
          </div>
          <div class="form-group col-md">
            <input v-money="money" class="form-control" type="text" v-model="optionalValue3"/>
          </div>
          <div class="form-group col-md">
            <input v-money="money" class="form-control" type="text" v-model="optionalValue4"/>
          </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4>Logo</h4>
        <span>Adicione a logo da sua Organização Social.</span>
      </div>

      <div class="col-md-8">
        <div class="photo-container row">
          <div class="col-md-4">
            <img @click.stop.prevent="selectLogo()" :src="logo"/>
            <input ref="uploadBtnLogo" class="input-photo" type="file" @change="uploadLogo" />
          </div>
          <div class="col-md-6" v-if="!isUploadingLogo">
            <span>Clique na imagem ao lado para adicionar uma nova foto.</span>
            <span>Tamanho recomendado 500x500. Max 2,5MB</span>
          </div>
          <div class="col-md-6" v-else>
            <span>Aguarde...</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4>Foto de Capa</h4>
        <span v-if="project.projectType == 'event'">Adicione uma imagem que represente o seu evento.</span>
        <span v-else>Adicione uma imagem que represente sua Organização Social.</span>
      </div>

      <div class="col-md-8">
        <div class="photo-container row">
          <div class="col-md-4">
            <img @click.stop.prevent="selectPhoto()" :src="picture"/>
            <input ref="uploadBtn" class="input-photo" type="file" @change="uploadPhoto" />
          </div>
          <div class="col-md-6" v-if="!isUploadingPicture">
            <span>Clique na imagem ao lado para adicionar uma nova foto.</span>
            <span>Tamanho recomendado 800x600. Max 2,5MB</span>
          </div>
          <div class="col-md-6" v-else>
            <span>Aguarde...</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4>Vídeo</h4>
        <span>Opcional. Adicione um vídeo para atrair mais doadores.</span>
      </div>

      <div class="col-md-8">
        <div class="embed-container" v-if="showVideo">
          <iframe :src="video" frameborder="0" allowfullscreen></iframe>
        </div>
        <div class="form-group">
          <input type="text" class="form-control" v-model="video"/>
          <span>Somente Youtube.</span>
        </div>
      </div>
    </div>

    <div class="row" v-if="project.projectType != 'event'">
      <div class="col-md-4">
        <h4>Categorias</h4>
        <span>Escolha até duas categorias para os doadores encontrarem seu projeto mais facilmente.</span>
      </div>

      <div class="col-md-8">
        <div v-if="categoriesLimit" class="alert alert-danger alert-dismissible fade show" role="alert">
          Você já atingiu o limite de categorias.
        </div>
        <b-form-checkbox-group id="checkboxes2" name="flavour2" v-model="categories">
          <b-form-checkbox v-for="c in categoriesList" v-bind:key="c.CategoryId" class="col-md-3" :value="c.CategoryId">{{c.name}}</b-form-checkbox>
        </b-form-checkbox-group>
      </div>
    </div>

    <div class="row" v-if="project.projectType != 'event'">
      <div class="col-md-4">
        <h4>Agenda 2030 ONU</h4>
        <span>Escolha as ODS que representam o seu projeto.</span>
      </div>

      <div class="col-md-8">
        <b-form-checkbox-group id="checkboxes2" name="flavour2" v-model="ods">
          <b-form-checkbox v-for="o in odsList" :key="o.number" class="col-md-3" :value="o.slug">{{o.title}}</b-form-checkbox>
        </b-form-checkbox-group>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4>Localização</h4>
        <span v-if="project.projectType == 'event'">Onde será o evento?</span>
        <span v-else>Em qual cidade seu projeto se encontra?</span>
      </div>

      <div class="col-md-8">
        <div class="form-group">
          <input type="text" class="form-control" v-model="city" :placeholder="project.projectType == 'event' ? 'Local do evento' : 'Nome da cidade'"/>
        </div>
      </div>
    </div>

    <div class="row" v-if="project.projectType != 'event'">
      <div class="col-md-4">
        <h4>Descrição curta</h4>
        <span>
          Descreva seu projeto em poucas palavras.
          Essa descrição ficará na miniatura do seu projeto em nossa página principal.
        </span>
      </div>

      <div class="col-md-8">
        <div class="form-group">
          <input class="form-control" type="text" v-model="shortDescription" maxlength="100"/>
          <span>Até 100 caracteres.</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4 v-if="project & project.projectType == 'event'">Descrição do Evento</h4>
        <h4 v-else>Descrição</h4>
        <span v-if="project & project.projectType == 'event'">Descreva o evento e conte para os convidados sobre o propósito e projeto social que toca o seu coração.</span>
        <span v-else>Descreva seu projeto. Conte por quê você precisa de doações e qual o propósito delas.</span>
      </div>

      <div class="col-md-8">
        <div class="form-group">
          <vue-editor v-model="description"></vue-editor>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4>Site</h4>
        <span>Informe o site do seu projeto ou organização.</span>
      </div>

      <div class="col-md-8">
        <div class="form-group">
          <input type="text" class="form-control" v-model="site"/>
        </div>
      </div>
    </div>

    <div class="row" v-if="project.projectType != 'event'">
      <div class="col-md-4">
        <h4>Habilidades</h4>
        <span>Escolha na lista aquilo que sua ONG necessita para que possamos conectar com aqueles que possuem estas habilidades.</span>
      </div>

      <div class="col-md-8">
        <b-form-group>
          <b-form-checkbox-group id="checkbox-group-2" v-model="selectedHabilities" name="habilities" stacked>
            <b-form-checkbox v-for="(c, k) in arrHabilitiesWithMessages" size="lg" :value="c.hability" :key="k">{{ c.message }}</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4>Exposição</h4>
        <span>Como quer aparecer em nosso site?</span>
      </div>

      <div class="col-md-8">
        <b-form-radio-group id="radios4" v-model="visibility" name="radioSubComponent">
            <div class="col-md-4" v-if="project.projectType != 'event'">
              <b-form-radio value="public">Público</b-form-radio>
            </div>
            <div class="col-md-8" v-if="project.projectType != 'event'">
              <span>Projetos públicos aparecem na busca do site e Google</span>
            </div>
            <div class="col-md-4">
              <b-form-radio value="private">Privado</b-form-radio>
            </div>
            <div class="col-md-8">
              <span>Projetos privados só são visíveis através deste endereço: <a target="_blank" :href="'https://click2giv.com/' + project.slug">https://click2giv.com/project/{{project.slug}}</a></span>
            </div>
            <div class="col-md-4">
              <b-form-radio value="inactive">Inativo</b-form-radio>
            </div>
            <div class="col-md-8">
              <span>Projetos inativos não são exibidos</span>
            </div>
          </b-form-radio-group>
      </div>
    </div>

    <div class="row" v-if="project.projectStatus == 'disabled'">
      <div class="col-md-4">
        <h4>Status do Projeto</h4>
        <span>Acompanhe aqui o status de publicação do seu projeto.</span>
      </div>

      <div class="col-md-8">
        <div v-if="!project.projectUnallowed">
          <h4 v-if="validated">Projeto aguardando avaliação</h4>
          <h4 v-else>Projeto com informações pendentes</h4>
          <span v-if="validated">Parabéns! Seu projeto está completo, e será analisado para liberação dentro do prazo de 24 horas por nossa equipe de curadoria.</span>
          <span v-else>Preencha todos os campos obrigatórios e aguarde a avaliação da nossa equipe de curadoria.</span>
        </div>
        <div v-else>
          <h4>Projeto Rejeitado</h4>
          <span>Seu projeto foi rejeitado! Motivo: {{ project.projectUnallowedMessage }}</span>
        </div>
      </div>
    </div>

    <div class="row" id="saveBar">

      <div class="col-md-6">
        <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
          {{msg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="showSuccessMsg" class="alert alert-success alert-dismissible fade show" role="alert">
          {{successMsg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="col-md-4">
        <button class="btn" v-on:click.stop.prevent="save()">Salvar Projeto</button>
      </div>
    </div>

    <b-modal size="lg" v-model="showHabilityModal" title="Selecione sua Habilidade" v-if="project.projectType != 'event'">
      <p>
        A Click2giv é uma plataforma que tem por objetivo aproximar pessoas, conectar aqueles que desejam contribuir, com aqueles que necessitam de contribuição. <br><br>
        Agora sua Organização Social pode contar com uma rede de apoio de voluntários e pessoas que estão dispostas a ajudar com aquilo que sabem. <br><br>
        Escolha na lista abaixo aquilo que sua ONG necessita para que possamos conectar com aqueles que possuem estas habilidades:
      </p>

      <b-form-group>
        <b-form-checkbox-group id="checkbox-group-6" v-model="selectedHabilities" name="modal-habilities" stacked>
          <b-form-checkbox v-for="(c, k) in arrHabilitiesWithMessages" size="lg" :value="c.hability" :key="k">{{ c.message }}</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <!-- <div class="row">
      <div class="col-md-4">
        <button class="btn clear-project" v-on:click.stop.prevent="erase()">Apagar Projeto</button>
      </div>

      <div class="col-md-8">
        <span>Tem certeza? Não será possível restaurar seu projeto. Todos os acessos serão redirecionados.</span>
      </div>
    </div> -->
  </div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'
import { VueEditor } from 'vue2-editor'
import {VMoney} from 'v-money'

export default {
  name: 'ProjectInfo',
  props: ['project', 'validated'],
  components: {
    VueEditor
  },
  directives: {money: VMoney},
  data(){
    return {
      msg: '',
      successMsg: '',
      showMsg: false,
      showSuccessMsg: false,
      projectId: false,
      title: null,
      slug: null,
      donationType: 'single',
      donationTotal: null,
      minimumValue: 0.0,
      optionalValue1: 2000,
      optionalValue2: 2500,
      optionalValue3: 5000,
      optionalValue4: 10000,
      picture: null,
      logo: null,
      video: null,
      showVideo: false,
      categories: null,
      categoriesList: null,
      categoriesLimit: false,
      ods: null,
      odsList: Functions.getOdsList(),
      city: null,
      shortDescription: null,
      description: null,
      site: null,
      visibility: 'inactive',
      page: 'info',
      isUploadingLogo: false,
      isUploadingPicture: false,
      selectedHabilities: [],
      showHabilityModal: false,
      arrHabilitiesWithMessages: [
        {
          'message': 'Estamos precisando de alguém com conhecimento em apresentações (Powerpoint)',
          'hability': 'designer'
        },
        {
          'message': 'Precisamos de um designer (logotipo, site, artes para convites, etc)',
          'hability': 'criacao'
        },
        {
          'message': 'Gostaríamos de ter contato com um advogado (revisão de contratos)',
          'hability': 'advogado'
        },
        {
          'message': 'Precisamos de palestrantes (negócios, empreendedorismo, saúde, marketing digital, habilidades pessoais)',
          'hability': 'empreendedor'
        },
        {
          'message': 'Precisamos de um programador (manutenção de site, integração com API, etc)',
          'hability': 'programador'
        },
        {
          'message': 'Precisamos de um(a) redator(a) para melhorar os textos de nossas campanhas',
          'hability': 'redator'
        },
        {
          'message': 'Gostaríamos de conversar com especialista em marketing digital',
          'hability': 'marketing'
        },
        {
          'message': 'Precisamos conversar com especialista em captação de recursos',
          'hability': 'influencer'
        },
        {
          'message': 'Queremos cursos e treinamentos gratuitos para nossos colaboradores',
          'hability': 'palestrante'
        },
        {
          'message': 'Gostaríamos de conhecer ferramentas gratuitas de gestão e colaboração',
          'hability': 'ti'
        },
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  created(){
    this.loadCategories();
    this.projectId = this.project.ProjectId;
    this.donationType = this.project.donationType;
    this.donationTotal = this.project.donationTotal * 100;
    this.minimumValue = this.project.minimumValue * 100;

    this.optionalValue1 = (this.project.optionalValues) ? this.project.optionalValues.optionalValue1 * 100 : 2000;
    this.optionalValue2 = (this.project.optionalValues) ? this.project.optionalValues.optionalValue2 * 100 : 2500;
    this.optionalValue3 = (this.project.optionalValues) ? this.project.optionalValues.optionalValue3 * 100 : 5000;
    this.optionalValue4 = (this.project.optionalValues) ? this.project.optionalValues.optionalValue4 * 100 : 10000;

    this.visibility = this.project.visibility;

    this.ods = this.project.ODS;

    if(this.project.Info){
      this.title = this.project.Info.title;
      this.slug = this.project.slug;
      this.shortUrlToken = this.project.shortUrlToken;
      this.logo = (this.project.Info.logo) ? this.project.Info.logo : 'https://via.placeholder.com/200x200?text=Sem+Logo';
      this.picture = (this.project.Info.image) ? this.project.Info.image : 'https://via.placeholder.com/500x500?text=Sem+Foto';
      this.video = this.project.Info.video;
      if(this.video){
        this.showVideo = true;
      }
      this.city = this.project.Info.city;
      this.shortDescription = this.project.Info.shortDescription;
      this.description = this.project.Info.description;
      this.site = this.project.Info.site;

      if(!this.project.habilities){
        this.showHabilityModal = true;
      }else{
        this.habilities = this.project.habilities;
      }
    }
  },
  mounted (){

  },
  methods: {
    loadCategories(){
      this.$http.get(API.Projects.categories).then((res) => {
        this.categoriesList = res.body;
        if(this.project.Categories){
          this.categories = this.project.Categories.map((c) => {
            return c.CategoryId
          })
        }
      })
    },
    save(){
      this.$emit('showloading');
      this.hideMessage();
      if(this.validate()){
        var categoriesList = this.categoriesList;
        if(this.categories){
          var categories = this.categories.map((c) => {
            var cat = categoriesList.filter((f) => {
              return c == f.CategoryId
            })
            return {...cat[0]}
          })
        }
        var donationTotal = (this.donationTotal) ? parseFloat(this.donationTotal.replace("R$ ", "").replace(".", "").replace(",", ".")) : null;
        var minimumValue = (this.minimumValue) ? parseFloat(this.minimumValue.replace("R$ ", "").replace(".", "").replace(",", ".")) : null;

        var optionalValue1 = (this.optionalValue1) ? parseFloat(this.optionalValue1.replace("R$ ", "").replace(".", "").replace(",", ".")) : null;
        var optionalValue2 = (this.optionalValue2) ? parseFloat(this.optionalValue2.replace("R$ ", "").replace(".", "").replace(",", ".")) : null;
        var optionalValue3 = (this.optionalValue3) ? parseFloat(this.optionalValue3.replace("R$ ", "").replace(".", "").replace(",", ".")) : null;
        var optionalValue4 = (this.optionalValue4) ? parseFloat(this.optionalValue4.replace("R$ ", "").replace(".", "").replace(",", ".")) : null;

        this.$http.post(API.Projects.updateProject + this.projectId,
          {
            title: this.title,
            donationType: this.donationType,
            donationTotal: donationTotal,
            minimumValue: minimumValue,
            optionalValues: {optionalValue1, optionalValue2, optionalValue3, optionalValue4},
            picture: this.picture,
            logo: this.logo,
            video: this.video,
            categories: categories,
            ods: this.ods,
            city: this.city,
            shortDescription: this.shortDescription,
            description: this.description,
            habilities: this.selectedHabilities,
            site: this.site,
            visibility: this.visibility,
            page: this.page
          }, {headers: auth.getHeaders()}).then((res) => {
            if(res.body.success === true){
              this.successMsg = res.body.message;
              this.showSuccessMsg = true;
              this.showVideo = true;
              this.$emit('reload');
            }else{
              this.showMessage(res.body.message);
            }
            this.$emit('hideloading');
          }, (err) => {
            this.showMessage(err.body.message);
            this.$emit('hideloading');
          });
      }else{
        this.$emit('hideloading');
      }
    },
    selectPhoto(){
      this.$refs.uploadBtn.click();
    },
    selectLogo(){
      this.$refs.uploadBtnLogo.click();
    },
    uploadPhoto(e){
      this.picture = 'https://via.placeholder.com/150x150?text=Carregando...';
      e.preventDefault();
      this.isUploadingPicture = true;
      var file = e.target.files[0]
      var reader = new FileReader();
      var $this = this;
      reader.addEventListener('loadend', (e) => {
        $this.$http.post(API.Projects.updateProject + this.projectId, {page: 'uploadPhoto', fileName: file.name, fileType: file.type}, {headers: auth.getHeaders()})
        .then((res) => {
          return $this.$http.put(res.body.uploadUrl, new Blob([reader.result], {type: file.type}), {headers: {'Content-Type': file.type, 'x-amz-acl': 'authenticated-read'}});
        })
        .then((res) => {
          var picture = res.url.split('?');
          $this.picture = picture[0] + '?' + new Date().getTime();
          $this.$forceUpdate();
          $this.isUploadingPicture = false;
        })
      })
      reader.readAsArrayBuffer(file);
    },
    uploadLogo(e){
      this.picture = 'https://via.placeholder.com/150x150?text=Carregando...';
      e.preventDefault();
      this.isUploadingLogo = true;
      var file = e.target.files[0]
      var reader = new FileReader();
      var $this = this;
      reader.addEventListener('loadend', (e) => {
        $this.$http.post(API.Projects.updateProject + this.projectId, {page: 'uploadLogo', fileName: file.name, fileType: file.type}, {headers: auth.getHeaders()})
        .then((res) => {
          return $this.$http.put(res.body.uploadUrl, new Blob([reader.result], {type: file.type}), {headers: {'Content-Type': file.type, 'x-amz-acl': 'authenticated-read'}});
        })
        .then((res) => {
          var picture = res.url.split('?');
          $this.logo = picture[0] + '?' + new Date().getTime();
          $this.$forceUpdate();
          $this.isUploadingLogo = false;
        })
      })
      reader.readAsArrayBuffer(file);
    },
    showMessage(msg){
      this.msg = msg;
      this.showMsg = true;
    },
    hideMessage(){
      this.successMsg = "";
      this.msg = "";
      this.showMsg = false;
      this.showSuccessMsg = false;
    },
    validate(){
      if(this.title == '' || this.title == null){
        this.showMessage("Insira o nome do projeto.");
        return false;
      }
      if(this.project.projectType != 'event'){
        if(!this.categories || this.categories.length == 0){
          this.showMessage("Você deve selecionar ao menos uma categoria.");
          return false;
        }
        if(this.project.projectType != 'event' && this.categories.length > 3){
          this.showMessage("Você só pode selecionar até duas categorias.");
          return false;
        }
      }
      var minimumValue = (this.minimumValue) ? parseFloat(this.minimumValue.replace("R$ ", "").replace(".", "").replace(",", ".")) : null;
      if(minimumValue < 20){
        this.showMessage("Valor mínimo deve ser igual ou superior à R$ 20.");
        return false;
      }
      return true;
    },
    editSlug()
    {
      var slug = Functions.stringToSlug(this.title + "-" + this.project.ProjectId.substring(0, 4));
      this.slug = slug;
    },
    erase(){

    }
  },
  watch: {
    categories(a){
      if(a && a.length > 3){
        this.categoriesLimit = true;
      }else{
        this.categoriesLimit = false;
      }
    },
    video(a){
      if(a){
        a = a.replace('watch?v=', 'embed/');
        a = a.replace('v/', 'embed/');
        this.video = a;
        if(a.length > 30){
          if(a.search("&") != -1){
            var arrVideo = a.split('&');
            if(arrVideo[0].search("embed") != -1){
              this.video = arrVideo[0];
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
span{
  font-size: 15px;
}
.input-photo{
  display: none;
}
.form-config{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .photo-container{
      img{
        width: 100%;
        cursor: pointer;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}
.embed-container{
  width: 100%;
  height: 250px;

  iframe{
    width: 100%;
    height: 100%;
  }
  padding-bottom: 20px;
}
#saveBar{
  position: fixed;
  bottom: 0;
  opacity: 0.4;
  border-top: thin solid #ddd;
  border-left: thin solid #ddd;
  border-top-left-radius: 10px;
  width: 100%;
  background-color: #fff;
  &:hover{
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manage-project/Info.vue